export default [
     {
          path: '/milestone-details/:id',
          name: 'MilestoneDetails',
          component: () => import("@/views/Page/StrategicPlan/Milestone/MilestoneDetails.vue"),
           meta: {
               title: 'MilestoneDetails',
               permission: 'Milestone.show',
          },
     }
];